<template>
  <div class="taskCenter">
    <router-view></router-view>
  </div>
</template>
<script>
export default {

}
</script>
<style scoped>
.taskCenter{
  display: flex;
  width: 100%;
  height: 100%;
}
</style>

